import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

function FormSectionTitle({ children }) {
  return (
    <Grid item xs={12} sx={{ marginTop: 2 }}>
      <h3 style={{ textAlign: "center", margin: 0, marginBottom: 8 }}>{children}</h3>
      <Divider variant="middle" component="aside" />
    </Grid>
  );
}

export { FormSectionTitle };
